module.exports = __webpack_public_path__ + "img/javaMobile4.6be30922.jpg";